import { toast } from "sonner";

export function raffleUrl(raffleId) {
  return `${window.location.origin}/r/${raffleId}`;
}

export function ticketUrl(orderId) {
  return `${window.location.origin}/t/${orderId}`;
}

export async function shareTicket(orderId, buyerName, raffleTitle) {
  const url = ticketUrl(orderId);
  const text = `Ticket de ${buyerName || "comprador"} — ${raffleTitle || "evento"} 🎟️`;
  try {
    if (navigator.share) {
      await navigator.share({ title: "Ticket de números", text, url });
      return;
    }
  } catch (e) {
    if (e && e.name === "AbortError") return; // el usuario canceló
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Enlace del ticket copiado");
  } catch (e) {
    toast.error("No se pudo copiar el enlace");
  }
}

export async function shareRaffle(raffleId, title) {
  const url = raffleUrl(raffleId);
  const text = `¡Participa en el evento "${title || "evento"}"! 🎟️ Aparta tus números aquí:`;
  try {
    if (navigator.share) {
      await navigator.share({ title: title || "Evento", text, url });
      return;
    }
  } catch (e) {
    if (e && e.name === "AbortError") return; // user cancelled
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Enlace copiado al portapapeles");
  } catch (e) {
    toast.error("No se pudo compartir el enlace");
  }
}
